import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";

function VerificationPending() {
  return (
    <div className="min-h-screen bg-[#fafafa] flex items-center justify-center p-6 font-sans text-gray-900 selection:bg-primary-100 selection:text-primary-900">

      {/* Background Decor */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary-100/40 rounded-full blur-[100px]"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] bg-secondary/10 rounded-full blur-[100px]"></div>
      </div>

      <div className="relative w-full max-w-lg bg-white rounded-3xl shadow-xl shadow-gray-200/50 p-6 md:p-10 text-center border border-white/50 backdrop-blur-xl">

        {/* Brand */}
        <div className="flex justify-center mb-6">
          <img src="https://www.exploreworld.com/_next/image?url=%2Fexploreworld-logo.png&w=256&q=75" alt="Supplier Central" className="h-8 w-auto" />
        </div>

        {/* Main Status Visual */}
        <div className="relative mx-auto w-24 h-24 mb-8">
          <div className="absolute inset-0 bg-yellow-50 rounded-full animate-ping opacity-20"></div>
          <div className="relative w-24 h-24 bg-yellow-50 rounded-full flex items-center justify-center border-4 border-white shadow-lg shadow-yellow-100">
            <i className="fi fi-rr-time-check text-4xl text-yellow-500"></i>
          </div>
          <div className="absolute -bottom-1 -right-1 bg-white rounded-full p-1.5 shadow-sm border border-gray-100">
            <div className="w-4 h-4 bg-yellow-500 rounded-full animate-pulse"></div>
          </div>
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-3 tracking-tight">Verification Pending</h1>
        <p className="text-gray-500 text-lg leading-relaxed mb-10">
          Thanks for registering! We are currently reviewing your business details and documents.
        </p>

        {/* Status Tracker */}
        <div className="bg-gray-50/80 rounded-2xl p-6 mb-10 border border-gray-100 text-left">
          <div className="space-y-6">
            {/* Step 1: Done */}
            <div className="flex gap-4">
              <div className="flex flex-col items-center">
                <div className="w-6 h-6 rounded-full bg-primary-600 flex items-center justify-center shadow-lg shadow-primary-600/20 z-10">
                  <i className="fi fi-rr-check text-white text-[10px] font-bold"></i>
                </div>
                <div className="flex-1 w-0.5 bg-primary-200 my-1"></div>
              </div>
              <div className="pb-1">
                <h4 className="text-sm font-bold text-gray-900">Registration Submitted</h4>
                <p className="text-xs text-gray-500 mt-0.5">Your details have been received securely.</p>
              </div>
            </div>

            {/* Step 2: Current */}
            <div className="flex gap-4">
              <div className="flex flex-col items-center">
                <div className="w-6 h-6 rounded-full bg-yellow-500 flex items-center justify-center shadow-lg shadow-yellow-500/20 z-10 shrink-0">
                  <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                </div>
                <div className="flex-1 w-0.5 bg-gray-200 my-1"></div>
              </div>
              <div className="-mt-1 pb-1">
                <h4 className="text-sm font-bold text-gray-900">Under Review</h4>
                <p className="text-xs text-gray-500 mt-0.5">Our team is verifying your information. This usually takes <span className="font-semibold text-gray-700">up to 24 hours</span>.</p>
              </div>
            </div>

            {/* Step 3: Next */}
            <div className="flex gap-4">
              <div className="flex flex-col items-center">
                <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center z-10 shrink-0 border-2 border-white ring-1 ring-gray-100">
                  <i className="fi fi-rr-lock text-gray-400 text-[10px]"></i>
                </div>
              </div>
              <div className="-mt-1">
                <h4 className="text-sm font-bold text-gray-400">Account Activation</h4>
                <p className="text-xs text-gray-400 mt-0.5">You'll receive an email once approved.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          {/* Primary Action is typically 'Back to Home' or similar since they can't login yet */}
          <Link
            to="/login"
            className="block w-full py-3.5 px-6 bg-white border border-gray-200 text-gray-700 font-bold rounded-xl hover:bg-gray-50 hover:text-gray-900 transition-all shadow-sm hover:shadow-md"
          >
            Return to Login Page
          </Link>

          <p className="text-xs text-gray-400 font-medium">
            Questions? <a href="#" className="text-primary-600 hover:text-primary-700 hover:underline">Contact Supplier Support</a>
          </p>
        </div>

      </div>
    </div>
  );
}

export default VerificationPending;